import React from "react";
import Clermont from "./Clermont";
import Davenport from "./Davenport";
import WinterHaven from "./WinterHaven";
import Kissimmee from "./Kissimmee";

const Contact = () => {
  return (
    <div>
      <h1>Locations</h1>
      <Clermont />
      <p>
        <br />
      </p>
      <div className="ui divider"></div>
      <p>
        <br />
      </p>
      <Davenport />
      <p>
        <br />
      </p>
      <div className="ui divider"></div>
      <p>
        <br />
      </p>
      <WinterHaven />
      <p>
        <br />
      </p>
      <div className="ui divider"></div>
      <p>
        <br />
      </p>
      <Kissimmee />
    </div>
  );
};

export default Contact;
